"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchWrapper = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _mediaTemplates = _interopRequireDefault(require("../../../../utils/mediaTemplates"));
var _sharedStyle = require("../sharedStyle");
var _templateObject;
const {
  colours
} = _uiKit.theme;
const SearchWrapper = exports.SearchWrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchPanelstyle__SearchWrapper",
  componentId: "sc-1ysxqzx-0"
})(["padding:9px;border-bottom-right-radius:4px;background-color:", ";position:absolute;top:", "px;right:0px;box-shadow:10px 10px 20px 0 rgba(174,174,192,0.39);display:flex;flex-direction:row;width:416px;max-width:calc(100% - 60px);visibility:", ";", ";z-index:4;button{display:inline-block;}"], colours.WHITE, _sharedStyle.headerHeight, props => props.isShowing ? 'visible' : 'hidden', _mediaTemplates.default.smallPhone(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    right: 0;\n    width: 100vw;\n    max-width: 100vw;\n  "]))));